"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/teamSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSection3666sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "1.5s" | "2s" | "2.5s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/team/team-img-01.jpg" | "/Templates/Doccure/img/team/team-img-02.jpg" | "/Templates/Doccure/img/team/team-img-03.jpg" | "/Templates/Doccure/img/team/team-img-04.jpg" */
    src: string;
    /** Detected variants: "Dr. Anthony Perez" | "Dr. Sarah Mitchell" | "Dr. Karen Garcia" | "Dr. Tyler Morgan" */
    a0Text: ReactNode;
    /** Detected variants: "Macular Degeneration Expert" | "Senior Physiotherapist" | "Glaucoma Specialist" | "Vision Therapy Specialist" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-lg-6 col-md-6 col-sm-6" */
    className?: string;
    /** Detected variants: "team-item-eighteen wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "team-icon" */
    a0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
    /** Detected variants: "team-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "team-img" */
    alt?: string;
    /** Detected variants: "img-fluid team-img" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "team-content" */
    div1ClassName?: string;
    /** Detected variants: "" */
    a0ClassName2?: string;
    /** Detected variants: "#" */
    a0Href?: string;
    /** Detected variants: "custom-title name" */
    h30ClassName?: string;
    /** Detected variants: "roll" */
    p0ClassName?: string;
    socialIconItems?: TeamSectionIconsItem[];
};

type TeamSectionIconsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fab fa-facebook-f" | "fab fa-twitter" | "fab fa-instagram" | "fab fa-linkedin-in" */
    className: string;
    /** Detected variants: "icon" */
    aClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeEighteenTeamSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection3666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection3666sItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "licensed physiotherapists" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Meet Our Expert" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Professionals" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "title" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/title-img-3.jpg" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "team-shadow" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/team-shadow-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "team-shadow" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/team-shadow-2.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    teamSection3666s: TeamSection3666sItem[];
    teamSection3666sItemWrapper?: (item: TeamSection3666sItem, content: ReactNode) => ReactNode;
    teamSection3666sRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection3666sImageVisible?: boolean;
    teamSection3666sImageRenderer?: (item: TeamSection3666sItem, defaultNode: ReactNode) => ReactNode;
    teamSection3666sH3Visible?: boolean;
    teamSection3666sH3Renderer?: (item: TeamSection3666sItem, defaultNode: ReactNode) => ReactNode;
    teamSection3666sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection3666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSection3666sH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection3666sItem) => Partial<ComponentProps<"h3">>);
    teamSectionIconsItemWrapper?: (item: TeamSectionIconsItem, content: ReactNode) => ReactNode;
    teamSectionIconsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeEighteenTeamSectionGenerated: FC<HomeEighteenTeamSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "licensed physiotherapists",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Meet Our Expert",
    sectionDiv0Div0H20H2Text2 = "Professionals",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt = "title",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/title-img-3.jpg",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps,
    sectionImageWithBasePath0ImageAlt = "team-shadow",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/team-shadow-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "team-shadow",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/team-shadow-2.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    sectionDiv0Div1ClassName,
    teamSection3666s,
    teamSection3666sItemWrapper,
    teamSection3666sRenderer,
    teamSection3666sImageVisible,
    teamSection3666sImageRenderer,
    teamSection3666sH3Visible,
    teamSection3666sH3Renderer,
    teamSection3666sImageProps,
    teamSection3666sH3Props,
    teamSectionIconsItemWrapper,
    teamSectionIconsRenderer,
}) => {
    return (
        <section className="section team-section-eighteen">
            <div className="container">
                <div className="section-header-eighteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            <span className="title-img">
                                {renderNode(sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row row-gap-4"}>
                    {renderCollectionNode(
                        teamSection3666s,
                        (item: TeamSection3666sItem) => (
                            <div className={item.className ?? "col-xl-3 col-lg-6 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "team-item-eighteen wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "team-overlay"}>
                                        {renderItemNode(teamSection3666sImageVisible, teamSection3666sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "team-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid team-img"} {...(typeof teamSection3666sImageProps === "function" ? teamSection3666sImageProps(item) : (teamSection3666sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        <a href={item.href ?? "#"} className={item.a0ClassName ?? "team-icon"}>
                                            <i className={item.i0ClassName ?? "isax isax-arrow-right-1"}></i>
                                        </a>
                                    </div>
                                    <div className={item.div1ClassName ?? "team-content"}>
                                        {renderItemNode(teamSection3666sH3Visible, teamSection3666sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title name"} {...(typeof teamSection3666sH3Props === "function" ? teamSection3666sH3Props(item) : (teamSection3666sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                <a href={item.a0Href ?? "#"} className={item.a0ClassName2 ?? ""}>{item.a0Text}</a>
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "roll"}>{item.p0Text}</p>
                                        <div className="social-icon">
                                            {renderCollectionNode(
                                                item.socialIconItems ?? [],
                                                (item: TeamSectionIconsItem) => (
                                                    <a href={item.href ?? "#"} className={item.aClassName ?? "icon"} key={item.key}>
                                                        <i className={item.className}></i>
                                                    </a>
                                                ),
                                                teamSectionIconsItemWrapper,
                                                teamSectionIconsRenderer
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        teamSection3666sItemWrapper,
                        teamSection3666sRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-two" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeEighteenTeamSectionGenerated;
